import { IS_ANDROID_USER, IS_IOS_USER, IS_USER_AGENT_WITH_AVAILABLE_APP } from './userAgentUtils';

export const deeplinkUrl = (campaign, deeplink, osName) => {
  const params = new URLSearchParams();
  if (osName === 'android') {
    params.append('adj_t', process.env.ADJUST_CHANNEL_ANDROID);
  } else if (osName === 'ios') {
    params.append('adj_t', process.env.ADJUST_CHANNEL_IOS);
  } else {
    params.append('adj_t', `${process.env.ADJUST_CHANNEL_IOS}_${process.env.ADJUST_CHANNEL_ANDROID}`);
  }
  params.append('adj_campaign', campaign);

  return `${process.env.ADJUST_LINK}?${params.toString()}&deeplink=${window.encodeURIComponent(`${process.env.DEEPLINK_SCHEMA}://${deeplink || 'explore'}`)}`;
};

export const responsiveDeeplinkUrl = (
  campaign,
  deeplink,
  forceDeeplink = IS_USER_AGENT_WITH_AVAILABLE_APP,
) => {
  if (!forceDeeplink) {
    return 'https://www.fishbrain.com';
  }
  if (IS_ANDROID_USER) {
    return deeplinkUrl(campaign, deeplink, 'android');
  }
  if (IS_IOS_USER) {
    return deeplinkUrl(campaign, deeplink, 'ios');
  }
  return deeplinkUrl(campaign, deeplink);
};
